var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert-wrap"},[_c('img',{staticClass:"status-icon",attrs:{"src":require("../../assets/image/info-icon.png"),"alt":""}}),_c('p',{staticClass:"alert-title"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }